import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AngularCsv } from 'angular7-csv/dist/Angular-csv';
import { settings } from 'cluster';
import { ModalDirective } from 'ngx-bootstrap';
import { AppConfigService } from '../../../app.config';
import { DisplayModes } from '../../../models/enums';
import { HCP } from '../../../models/lookups/hcp.model';
import { Specialty } from '../../../models/lookups/speciality.model';
import { Page } from '../../../models/page.model';
import { AlertService, MessageSeverity } from '../../../services/alert.service';
import { AppTranslationService } from '../../../services/app-translation.service';
import { LookupsService } from '../../../services/lookups.service';
import { HcoService } from '../../../settings/components/hco/hco.service';
import { HCPService } from '../hcp.service';
import { PlanStatus } from '../../../plan/enums/plan-status.enum';
import { UsersApiService } from '../../../services/users-api.service';
import { SettingService } from '../../../settings/components/settings/setting.service';

@Component({
  selector: 'crm-review-add-hcp',
  templateUrl: './review-add-hcp.component.html',
  styleUrls: ['./review-add-hcp.component.css']
})
export class ReviewAddHcpComponent implements OnInit {

  columns: any[] = [];
  showEnglishName: boolean = false;
  users: any[] = [];

  searchText: string;
  search: any = {};
  totalItems: number = 0;
  currentPage: number = 1;
  pageSize = 10;
  countryId: number;
  displayMode: DisplayModes = DisplayModes.Success;
  hcps: HCP[] = [];
  @ViewChild('filterModal')
  filterModal: ModalDirective;
  reviewMode: boolean = false;
  selectedHcPId;
  @ViewChild('rejectModal')
  rejectModal: ModalDirective;
  specialities: Specialty[] = new Array<Specialty>();
  specialty: Specialty;
  selectedHcpId;
  public logo = require("../../../assets/images/demo/HCP Class.png");
  @ViewChild('hcosModal')
  hcosModal: ModalDirective;
  selectedHcos;
  csvOptions = {
    fieldSeparator: ',',
    quoteStrings: '"',
    decimalseparator: '.',
    showLabels: true,
    showTitle: true,
    title: 'HCO List :',
    useBom: true,
    noDownload: false,
    headers: ["ID", "Name", "Phone", "Email", "Speciality", "User Name"]
  };


  settings = {
    columns: {
      id: {
        title: 'ID'
      },
      name: {
        title: 'Name'
      },
      phone: {
        title: 'Phone'
      },
      email: {
        title: 'Email'
      },
      specialityName: {
        title: 'Speciality'
      }
    }
  };

  firstList: boolean = true;
  constructor(private readonly alertService: AlertService, private readonly usersService: UsersApiService,
    private readonly route: ActivatedRoute,
    private readonly lookupsService: LookupsService,
    private readonly hcpService: HCPService,
    private readonly appConfig: AppConfigService,
    private readonly translateService: AppTranslationService,
    private readonly settingService: SettingService,
    private readonly router: Router) { }

  ngOnInit() {
    if (this.appConfig && this.appConfig.settings && this.appConfig.settings.pageSize) {
      this.pageSize = this.appConfig.settings.pageSize;
    }
    this.getSpecialities();
    this.getAllUsers();
    this.searchHcps();

    this.columns = [
      { field: 'fullName', header: this.translateService.getTranslation("Name"), width: '20%' },
      { field: 'specialityName', header: this.translateService.getTranslation("pageHeader.speciality"), width: '15%' },
      { field: 'email', header: this.translateService.getTranslation("pageHeader.email"), width: '10%' },
      { field: 'phone', header: this.translateService.getTranslation("pageHeader.phone"), width: '15%' },
      { field: 'hcos', header: this.translateService.getTranslation("HCOs"), width: '15%' },
      { field: 'userName', header: this.translateService.getTranslation("hco.userName"), width: '15%' },
      { field: 'date', header: this.translateService.getTranslation("Date"), width: '15%' }

    ];
    this.getEnglishNameSetting();

  }

  getEnglishNameSetting() {
    this.settingService.getCustomFieldLabelConfig('HCPCostumFieldLabel').subscribe(config => {
      this.showEnglishName = config.show;
      if (config.show) {
        this.columns.splice(1, 0, { field: 'englishName', header: config.label, width: '15%' });
      }
    });
  }

  getAllUsers() {
    this.displayMode = DisplayModes.Loading;
    this.usersService.getAllUsersMiniReport().subscribe(response => {
      this.users = response as any[];

      this.displayMode = DisplayModes.Success;
    }, error => {
      this.displayMode = DisplayModes.Success;
      this.alertService.showStickyMessage("Load Data Error", "The below errors occured whilst fetch data from server:", MessageSeverity.Error, error);
      this.alertService.showStickyMessage(error, null, MessageSeverity.Error);

    });
  }

  searchHcps() {

    this.alertService.startLoadingMessage("", this.translateService.getTranslation("Searching"));
    let specialityId = (this.search.speciality == null) ? 0 : this.search.speciality.id;

    if (this.search.user)
      this.search.userId = this.search.user.id;

    this.hcpService.GetPendingApproval(this.search.searchText, specialityId, this.search.hcpClassId, this.pageSize, this.currentPage, this.search.startDate, this.search.endDate, this.search.userId).subscribe(response => {
      this.alertService.stopLoadingMessage();
      const result = response as Page;
      //this.hcps = [];
      //result.items.forEach(x => {
      //  if (this.hcos.filter(y => y.id == x.id).length == 0)
      //    this.hcos.push(x);
      //})

      this.hcps = result.items;
      this.totalItems = result.totalItems;


      this.hcps.forEach(i => { if (i.fullName && i.fullName.length > 30) { i.trimmedName = i.fullName.substring(0, 25) + '...'; } else i.trimmedName = i.fullName; });
      this.hcps.forEach(i => { if (i.email && i.email.length > 30) { i.trimmedEmail = i.email.substring(0, 25) + '...'; } else i.trimmedEmail = i.email; });
    }, err => {
      this.alertService.stopLoadingMessage();
      this.displayMode = DisplayModes.Error;
    });
  }
  cofirmHcp(hcp) {
    //this.displayMode = DisplayModes.Loading;
    this.alertService.startLoadingMessage("", this.translateService.getTranslation(`Confirming HCP, ${hcp.fullName} `));
    hcp.isApproved = true;
    hcp.addingStatus = PlanStatus.approved;
    this.hcpService.SaveHCP(hcp).subscribe(() => {
      this.alertService.stopLoadingMessage();
      // this.displayMode = DisplayModes.Success;
      this.searchHcps();
      //this.router.navigate(["settings/hcos/review-add-requests"]);
      this.alertService.showMessage("", this.translateService.getTranslation(`HCP ${hcp.fullName} confirmed successfully!`), MessageSeverity.Success);
    }, error => {
      this.alertService.stopLoadingMessage();
      this.displayMode = DisplayModes.Error;
      this.alertService.showStickyMessage("Save Error", "errors occured whilst confirming", MessageSeverity.Error, error);
      //this.alertService.showStickyMessage(error, null, MessageSeverity.Error);
    });

  }
  pageChanged(event) {
    this.currentPage = event.first / event.rows + 1;
    if (!this.firstList)
      this.searchHcps();
    else
      this.firstList = !this.firstList;
  }
  rejectAddRequest(hcp) {
    this.selectedHcpId = hcp.id;
    this.rejectModal.show();
  }

  deleteHCP() {
    // this.displayMode = DisplayModes.Loading;
    this.alertService.startLoadingMessage("", this.translateService.getTranslation(`rejecting HCP`));
    this.hcpService.rejectAddNewHcp(this.selectedHcpId).subscribe(() => {
      //this.displayMode = DisplayModes.Success;
      this.alertService.stopLoadingMessage();
      this.rejectModal.hide();
      this.alertService.showMessage("", this.translateService.getTranslation(`HCP Rejected!`), MessageSeverity.Success);
      this.selectedHcpId = undefined;
      this.searchHcps();
    }, (error) => {
      this.displayMode = DisplayModes.Success;
      //this.alertService.showMessage("", this.translateService.getTranslation("FailedToDelete"), MessageSeverity.Error);
      this.alertService.showStickyMessage("Rejecting error!", `An error occured during rejecting HCP,  please try again!`, MessageSeverity.Error, error);

    });
  }

  getSpecialities() {
    this.displayMode = DisplayModes.Loading;
    this.hcpService.GetAllSpecialities("").subscribe(response => {

      const results = response;
      this.specialities = results as Specialty[];
      this.displayMode = DisplayModes.Success;
      //setTimeout(() => this.specialitiesSelector.refresh());
    }, () => {
      this.displayMode = DisplayModes.Error;
    });
  }


  gotoReview(hcpId,) {
    this.selectedHcpId = hcpId;
    this.reviewMode = true;
  }

  openFilterModal() {
    this.filterModal.show();
  }

  hideFilterModal() {
    this.search.searchText = "";
    this.search.speciality = undefined;
    this.filterModal.hide();
  }

  searchFilterModal() {
    this.filterModal.hide();
    this.searchHcps();
  }


  closeReview(event) {
    this.selectedHcpId = undefined;
    this.reviewMode = false;

    if (event) {
      this.searchHcps();
    }
  }

  hideRejectModal() {
    this.rejectModal.hide();
  }


  downloadCSV() {

    this.displayMode = DisplayModes.Loading;

    const csvData = this.hcps.map(o => {
      return {
        id: o.id, name: o.fullName, phone: o.phone, email: o.email,
        Speciality: o.specialityName, CreatedByName: o.createdByName
      };
    });
    new AngularCsv(csvData, "Hcp list", this.csvOptions);
    this.displayMode = DisplayModes.Success;
  }


  showHcos(hcos) {
    this.selectedHcos = hcos
    this.hcosModal.show();
  }

}
